<template>
  <LineChart
    class="chart"
    :chart-data="{
      labels: dates,
      datasets: [
        {
          label: 'Forms',
          data: stats.map(stat => stat.totalForms),
          borderColor: '#3498db', // Nice blue
          backgroundColor: 'rgba(52, 152, 219, 0.2)', // Light blue fill
          fill: true,
        },
        {
          label: 'Payments',
          data: stats.map(stat => stat.payedForms),
          borderColor: '#2ecc71', // Nice green
          backgroundColor: 'rgba(46, 204, 113, 0.2)', // Light green fill
          fill: true,
        },
        {
          label: 'Conversion (%)',
          data: stats.map(stat => stat.conversionRate),
          borderColor: '#e74c3c', // Nice red
          backgroundColor: 'rgba(231, 76, 60, 0.2)', // Light red fill
          fill: true,
          // yAxisID: 'y-axis-2',
        },
      ],
    }"
  />
</template>

<script setup lang="ts">
import type { SerializedDb, VisaForm } from '~/types';
import { Chart, registerables } from 'chart.js';
import { LineChart } from 'vue-chart-3';
import { dateToIso, toEndOfDayIso, toStartOfDayIso } from '~/helpers/date';
import { isFormPayed } from '~/helpers/visa-form';

Chart.register(...registerables);

const props = defineProps<{
  forms: SerializedDb<VisaForm>[];
}>();

const dates = computed(() => {
  const start = new Date(toStartOfDayIso(props.forms[0].created_at));
  const end = new Date(toEndOfDayIso(props.forms.at(-1)!.created_at));
  const dates = [];
  for (let date = start; date <= end; date.setDate(date.getDate() + 1)) {
    dates.push(dateToIso(date));
  }
  return dates;
});

const stats = computed(() => {
  const data = dates.value.map(date => {
    const forms = props.forms.filter(form => form.created_at.startsWith(date));
    return {
      date,
      totalForms: forms.length,
      payedForms: forms.filter(isFormPayed).length,
    };
  });

  return data.map(({ date, totalForms, payedForms }) => ({
    date, totalForms, payedForms,
    conversionRate: (payedForms / totalForms) * 100,
  }));
});
</script>

<style scoped>
.chart {
  height: 600px;
}
</style>